
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  inheritAttrs: true,
})
export default class AppInput extends Vue {
  @Prop({
    default: 0,
  })
  public readonly debounce!: number;

  private _timerId: number | null = null;

  public input(value: string): void {
    if (!this.debounce) {
      this.$emit("input", value);
      return;
    }

    if (this._timerId) {
      clearTimeout(this._timerId);
    }

    this._timerId = window.setTimeout(() => {
      this.$emit("input", value);
    }, this.debounce);
  }
}
